import { render, staticRenderFns } from "./errorTag.vue?vue&type=template&id=ca68beaa&scoped=true&"
import script from "./errorTag.vue?vue&type=script&lang=js&"
export * from "./errorTag.vue?vue&type=script&lang=js&"
import style0 from "./errorTag.vue?vue&type=style&index=0&id=ca68beaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca68beaa",
  null
  
)

export default component.exports